import script from "./Fd6BudgetBalanceSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./Fd6BudgetBalanceSummary.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__